<div ng-controller="taskConfigGeneralController as taskConfigGenCtrl" class="task-config-general-controller">
    <c-auto-form config="taskConfigGenCtrl.autoFormConfig"></c-auto-form>
</div>